import React from 'react';

import { Button, colorType } from './Button';

interface ISubmitButton {
  margin?: string;
  isFetching?: boolean;
  disabled?: boolean;
  label?: string;
  color?: colorType;
  width?: string;
  onClick?: () => void;
}

export const SubmitButton = ({
  margin,
  isFetching,
  label = 'Save',
  color = 'blue',
  width = 'auto',
  disabled = false,
  onClick = undefined,
}: ISubmitButton) => (
  <Button
    margin={margin}
    type="submit"
    width={width}
    color={color}
    isFetching={isFetching}
    label={label}
    disabled={disabled}
    onClick={onClick}
  />
);
